export default function IconTextItalic({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1868 0.952274C11.8863 1.03556 11.6955 1.14544 11.4462 1.37874C10.8899 1.89912 10.7198 2.65075 10.9932 3.38146C11.107 3.68523 11.4584 4.09417 11.7558 4.26848C12.1714 4.51193 12.2064 4.51423 15.3907 4.51483C17.0139 4.51519 18.342 4.52571 18.342 4.53828C18.342 4.55569 9.91957 27.0311 9.77403 27.4021C9.74442 27.4774 9.56575 27.4825 6.93385 27.4831C3.90812 27.4837 3.85505 27.4873 3.44563 27.7273C3.33769 27.7905 3.15613 27.9422 3.04214 28.0643C2.26658 28.8953 2.43811 30.2149 3.40115 30.8264C3.87947 31.13 3.3233 31.1113 11.8391 31.1107C19.9937 31.1102 19.7715 31.1157 20.1751 30.9069C20.3978 30.7917 20.7534 30.4468 20.89 30.2137C21.1623 29.7491 21.2055 29.1512 21.0054 28.6165C20.8917 28.3127 20.5403 27.9038 20.2428 27.7295C19.8272 27.486 19.7924 27.4837 16.6079 27.4831C14.9848 27.4827 13.6567 27.4722 13.6567 27.4597C13.6567 27.4423 22.0791 4.9668 22.2246 4.59582C22.2542 4.52051 22.4329 4.51543 25.0648 4.51483C28.0955 4.51423 28.143 4.51096 28.5576 4.26799C28.8062 4.12233 29.1428 3.75353 29.2734 3.48373C29.6645 2.67601 29.3676 1.66051 28.5975 1.17155C28.1188 0.867658 28.6796 0.886274 20.1365 0.890746C14.0972 0.893889 12.348 0.907548 12.1868 0.952274Z"
        fill="currentColor"
      />
    </svg>
  )
}
